import { createIcon, Svg } from "@gluestack-ui/icon";
import { Path } from "react-native-svg";

const PeopleIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 20 17",
  path: (
    <>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        stroke="none"
        d="M12.5872 1.5189C12.7921 1.10675 13.2922 0.938677 13.7044 1.1435C15.2115 1.89248 16.2502 3.44916 16.2502 5.24996C16.2502 7.05076 15.2115 8.60744 13.7044 9.35642C13.2922 9.56124 12.7921 9.39317 12.5872 8.98102C12.3824 8.56887 12.5505 8.06872 12.9626 7.8639C13.925 7.38563 14.5835 6.39393 14.5835 5.24996C14.5835 4.10599 13.925 3.11429 12.9626 2.63602C12.5505 2.4312 12.3824 1.93105 12.5872 1.5189Z"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        stroke="none"
        d="M14.2409 12.6284C14.4307 12.2091 14.9244 12.023 15.3437 12.2127C16.742 12.8455 17.9786 13.866 18.9888 15.1518C19.2731 15.5137 19.2102 16.0376 18.8483 16.3219C18.4864 16.6062 17.9626 16.5434 17.6782 16.1815C16.8093 15.0755 15.7774 14.2384 14.6566 13.7312C14.2373 13.5414 14.0512 13.0477 14.2409 12.6284Z"
      />
      <Path
        fillRule="evenodd"
        stroke="none"
        clipRule="evenodd"
        d="M3.3335 5.24996C3.3335 2.71865 5.38553 0.666626 7.91684 0.666626C10.4481 0.666626 12.5002 2.71865 12.5002 5.24996C12.5002 7.78126 10.4481 9.83329 7.91684 9.83329C5.38553 9.83329 3.3335 7.78126 3.3335 5.24996Z"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        stroke="none"
        d="M1.01156 15.1518C2.75472 12.9332 5.18111 11.5 7.91684 11.5C10.6526 11.5 13.079 12.9332 14.8221 15.1518C15.0192 15.4026 15.0558 15.744 14.9163 16.0309C14.7769 16.3178 14.4859 16.5 14.1668 16.5H1.66684C1.34782 16.5 1.0568 16.3178 0.917343 16.0309C0.777887 15.744 0.814472 15.4026 1.01156 15.1518Z"
      />
    </>
  ),
});

PeopleIcon.displayName = "PeopleIcon";
export { PeopleIcon };
